export const SUBSCRIPTION_CONTRACT_META_KEY = {
    SALTO_CREATED_AT: "saltoCreatedAt",
    SALTO_CONTRACT_ID: "saltoContractId",
    SOURCE: "source",
    COMPANY: "company",
    INITIAL_SKU: "initialSku",
    GIFTS: "gifts",
    HAS_RECEIVED_GIFTS: "hasReceivedGifts",
    CANCEL_REASON: "cancelReason",
    CANCEL_SOURCE: "cancelSource",
    DO_NOT_SEND_CANCEL_EMAIL: "doNotSendCancelEmail",
    PERIODS_TO_SKIP: "periodsToSkip",
    PENDING_CONTRACT_APPROVED_AT: "pendingContractApprovedAt",
    CAMPAIGN_BOOKS: "campaignBooks",
    CAMPAIGN_SOURCE: "campaignSource",
    DISTRIBUTION_METHOD: "distributionMethod",
    DISTRIBUTION_MEDIA: "distributionMedia",
    SEND_EMAIL: "sendEmail",
    CHILD_NAME: "childName",
    CHILD_BIRTH_DATE: "childBirthDate",
    DISPATCH_BATCH_CODE: "dispatchBatchCode",
    PREVIOUS_CONTRACT_CREATED_AT: "previousContractCreatedAt",
};
export const SOURCE_VALUES = {
    TM: "TM",
    WEB: "WEB",
    SALTO: "SALTO",
    CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
};
export const CONTRACT_STATUS = {
    ENDED: "Avsluttet",
    PAUSED: "Pauset",
    ACTIVE: "Aktivt",
};
export const SKIP_REASONS = {
    UNKNOWN_ADDRESS: "Ukjent adresse",
};
